/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".container[_ngcontent-%COMP%]{margin-top:130px}.message[_ngcontent-%COMP%]{font-size:16px;white-space:pre-wrap;padding:2rem 2rem 2rem 4rem}"];
export { styles as styles };
